import React, { useState } from "react";
import { Table } from "react-bootstrap";
import { getClientNickname } from "../../../../tools";
import { getClientInfo } from "../StreamWatch/StreamWatchClients";
import ClientBalanceHistoryModal from "../ClientBalanceHistoryModal";

const getParticipationTypeLabel = (type) => {
    type = type.toLowerCase();
    if (type === 'online') return 'Онлайн';
    if (type === 'offline') return 'Офлайн';
    return type;
}

const getFieldValue = (client, field) => {
    const value = getClientInfo(client, field.name);

    if (['checkbox', 'disclaimer'].includes(field.type)) {
        return value ? 'Да' : 'Нет';
    }

    if (field.type === 'konturFocus') {
        return `${value.organizationName} (ИНН: ${value.organizationInn}, КПП: ${value.organizationKpp})`;
    }

    return value;
};

export default ({ event, activityTop }) => {
    const [balanceHistoryClient, setBalanceHistoryClient] = useState(null);

    if (!activityTop.length) {
        return <p>Нет данных</p>
    }

    return (
        <article>
            {activityTop.map((activityTopItem, index) =>
                <div key={index}>
                    {(activityTopItem.stream || activityTopItem.date) &&
                        <div>
                            {activityTopItem.stream &&
                                <span>
                                    <b style={{ marginRight: 5 }}>Зал</b>
                                    {activityTopItem.stream.description_ru}
                                </span>
                            }
                            {activityTopItem.date &&
                                <span>
                                    <b style={{ marginRight: 5 }}>Дата</b>
                                    {activityTopItem.date}
                                </span>
                            }
                        </div>
                    }
                    <Table>
                        <thead>
                            <tr>
                                <th style={{ width: 40 }}>#</th>
                                <th style={{ width: 40 }}>ID</th>
                                <th>eMail</th>
                                <th>Имя</th>
                                {event.registrationFields.map(({ field }) => (
                                    <th
                                        key={field.name}
                                        style={{ maxWidth: '300px' }}
                                    >
                                        <span
                                            style={{
                                                display: '-webkit-box',
                                                height: '18px',
                                                overflow: 'hidden',
                                                WebkitLineClamp: 1,
                                                WebkitBoxOrient: 'vertical',
                                            }}
                                        >
                                            {field.label_ru}
                                        </span>
                                    </th>
                                ))}
                                <th style={{ width: 80 }}>Формат</th>
                                <th style={{ width: 80 }}>Баллы</th>
                            </tr>
                        </thead>
                        <tbody>
                            {activityTopItem.top.map((value, index) =>
                                <tr key={index} style={{ cursor: 'pointer' }} onClick={() => setBalanceHistoryClient(value.client)}>
                                    <td>{index + 1}</td>
                                    <td>{value.client?.reg_id}</td>
                                    <td>{value.client?.email || value.client?.info?.email || ''}</td>
                                    <td>{value.client?.info?.name || getClientNickname(value.client)}</td>
                                    {event.registrationFields.map(({ field }) => (
                                        <td key={field.name}>{getFieldValue(value.client, field) || ''}</td>
                                    ))}
                                    <td>{getParticipationTypeLabel(value.client?.participationType || value.client?.info?.participationType || '')}</td>
                                    <td>{value.points}</td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                    <ClientBalanceHistoryModal client={balanceHistoryClient} onHide={() => setBalanceHistoryClient(null)} />
                </div>
            )}
        </article>
    );
}
